import { Component, ViewChild } from '@angular/core';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';
import { BillsService } from '../../../../../../bills/services/bills.services';
import { IBillItem } from '../../../../../../bills/bills.interface';
import { ClipboardService } from 'ngx-clipboard';
import { SendBillDocumentEmailComponent } from '../../../../../../bills/component/sub-components/send-bill-document-email/send-bill-document-email.component';

@Component({
  selector: 'app-case-bill-list',
  templateUrl: './case-bill-list.component.html',
  styleUrl: './case-bill-list.component.scss',
})
export class CaseBillListComponent {
    @ViewChild('sendEmail') emailCom: SendBillDocumentEmailComponent;

  constructor(
    private readonly msgService: AppMessageService,
    private readonly billService: BillsService,
    private readonly clipboardService: ClipboardService
  ) {}

  caseId: number | null;
  bills: IBillItem[];
  totalRecords: number;
  showCopied: boolean = false;
  openDialog: boolean = false;
  loading: boolean = false;

  trackById = (_: number, row: { id: number }) => row.id;
  initilize(data: { caseId: number }) {
    this.caseId = data?.caseId ?? null;
    if (!this.caseId) {
      this.msgService.errorToast('Vaka Id bulunamadı', '');
      return;
    }
    this.loading = true;
    this.billService.getBillsByCaseId(this.caseId).subscribe({
      next: (res) => {
        this.bills = res.success ? res?.items ?? [] : [];
        this.totalRecords = this.bills.length;
        this.openDialog = true;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  copySText(bill: IBillItem, param: 'id' | 'billNo' | 'caseNo'): void {
    const obj: any = {
      id: bill.id,
      caseNo:
        bill?.cases?.caseType?.valueObject?.code?.value +
        '' +
        bill?.cases?.caseNo,
      billNo: bill?.billNo,
    };
    this.clipboardService.copyFromContent(obj[param]);
    this.showCopied = true;
    setTimeout(() => {
      this.showCopied = false;
    }, 1000);
  }


   getBillDocument(billId:number) {
    if (billId) {
      this.billService.getBillDocument(billId).subscribe({
        next: (res) => {
          const blob = res.body as Blob;

          (async () => {
            const head = await blob.slice(0, 4).text();

            // 3) PDF değilse bile PDF mime’ı zorla
            const pdfBlob =
              head === '%PDF'
                ? blob
                : new Blob([blob], { type: 'application/pdf' });

            const url = URL.createObjectURL(pdfBlob);

            const w = window.open('', '_blank');
            if (w) {
              w.location.href = url;
              setTimeout(() => URL.revokeObjectURL(url), 60000);
            } else {
              const a = document.createElement('a');
              a.href = url;
              a.download = 'document.pdf';
              a.click();
              setTimeout(() => URL.revokeObjectURL(url), 10000);
            }
          })();
        },
        error: (err) => {
          console.error('PDF indirme hatası', err);
        },
      });
    }
  }

   sendDocEmail(billId:number,email:string|null) {
    if (billId) {
      this.emailCom.initilize(
        billId,
        email ?? null
      );
    }
  }

  clearData() {
    this.bills = [];
    this.caseId = null;
    this.totalRecords = 0;
  }
}
